<template>
    <section class="py-10 xl:pt-20 xl:pb-[96px] overflow-hidden will-change" :data-scroll-section="inner == 'false'">
        <div class="px-content mb-12">
            <h2 class="text-[28px] xl:text-heading mb-16" v-show="blockData.title">{{ blockData.title }}</h2>
        </div>

        <template v-if="!isMobile">
            <div class="px-content grid grid-cols-1 md:grid-cols-3 gap-3 xl:gap-6 overflow-hidden">

                <a  class="relative overflow-hidden cursor-pointer after:block after:bg-black after:opacity-20 after:absolute after:w-full after:h-full after:z-[8] after:top-0 after:left-0 hover:after:opacity-50 after:transition-opacity" v-show="blockData.cards" v-for="( card, index ) in blockData.cards" :key="index" :href="card.cta.url">

                    <XyzTransition appear-visible duration="auto" class="custom-easing-1" xyz="fade big-25% duration-30">
                        <img  class="object-cover w-full h-full" v-show="card.image" :src="card.image.url" :alt="card.image.alt">
                    </XyzTransition>

                    <h4 class="text-2xl font-normal text-white text-center px-4 w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  z-10" v-show="card.title">{{ card.title }}</h4>

                </a>

            </div>
        </template>

        <template v-else>
            <div class=" custom-slider">
                <div  class="swiper-container" ref="exploreCards">
                    <div class="swiper-wrapper pl-content">
                        <div v-for="( card, index ) in blockData.cards" :key="index" class="swiper-slide">
                            <a  class="block w-full h-full relative overflow-hidden cursor-pointer after:block after:bg-black after:opacity-20 after:absolute after:w-full after:h-full after:z-[8] after:top-0 after:left-0 hover:after:opacity-50 after:transition-opacity" :href="card.cta.url">

                                <img  class="object-cover w-full" v-show="card.image" :src="card.image.url" :alt="card.image.alt">

                                <h4 class="text-2xl font-normal text-white text-center px-4 w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  z-10" v-show="card.title">{{ card.title }}</h4>

                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </section>
</template>


<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
    export default {
        name: 'ExploreCards',
        data() {
            return {
                /* Mobile Explore more slider */
                exploreCards: null,
                exploreCardsOptions:{
                    slidesPerView: 1,
                    spaceBetween: 16,
                    navigation: false,
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 16,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 16,
                        },
                    }
                }
            }
        },
        mounted() {
            this.exploreCards = new Swiper( this.$refs.exploreCards, this.exploreCardsOptions );
        },
        methods: {
            goToLocation(card) {
                window.location.href = card.cta.url;
            }
        },
    }
</script>

<style>
  .custom-easing-1 {
    --xyz-ease: cubic-bezier(0,.83,0,1);
  }
</style>
